(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-own-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-builder')) {
    class BundleBuilder extends HTMLElement {
      connectedCallback() {
        this.maxItems = Number(this.dataset.maxItems || 6);
        this.selections = new Map();
        this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
        this.summary = this.querySelector('[data-bundle-summary]');
        this.status = this.querySelector('[data-bundle-status]');
        this.progress = this.querySelector('[data-bundle-progress]');
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.addButton = this.querySelector('[data-bundle-add]');
        this.clearButton = this.querySelector('[data-bundle-clear]');
        this.message = this.querySelector('[data-bundle-message]');
        this.search = this.querySelector('[data-bundle-search]');
        this.noResults = this.querySelector('[data-no-results]');

        this.cards.forEach((card) => {
          const increase = card.querySelector('[data-bundle-increase]');
          const decrease = card.querySelector('[data-bundle-decrease]');
          if (increase) increase.addEventListener('click', () => this.changeQuantity(card, 1));
          if (decrease) decrease.addEventListener('click', () => this.changeQuantity(card, -1));
        });

        if (this.addButton) this.addButton.addEventListener('click', () => this.addBundle());
        if (this.clearButton) this.clearButton.addEventListener('click', () => this.clearSelections());
        if (this.search) this.search.addEventListener('input', () => this.filterProducts());
        this.render();
      }

      get totalItems() {
        return Array.from(this.selections.values()).reduce((total, item) => total + item.quantity, 0);
      }

      changeQuantity(card, change) {
        const variantId = card.dataset.variantId;
        const title = card.dataset.productTitle;
        const current = this.selections.get(variantId) || { title, quantity: 0 };
        const nextQuantity = current.quantity + change;

        if (change > 0 && this.totalItems >= this.maxItems) {
          this.message.textContent = this.dataset.limitMessage;
          return;
        }

        this.message.textContent = '';
        if (nextQuantity <= 0) {
          this.selections.delete(variantId);
        } else {
          this.selections.set(variantId, { title, quantity: nextQuantity });
        }
        this.render();
      }

      render() {
        const total = this.totalItems;
        this.cards.forEach((card) => {
          const variantId = card.dataset.variantId;
          const quantity = this.selections.get(variantId)?.quantity || 0;
          const output = card.querySelector('[data-bundle-quantity]');
          const decrease = card.querySelector('[data-bundle-decrease]');
          const increase = card.querySelector('[data-bundle-increase]');
          if (output) output.textContent = quantity;
          if (decrease) decrease.disabled = quantity === 0;
          if (increase) increase.disabled = total >= this.maxItems;
          card.classList.toggle('is-selected', quantity > 0);
        });

        if (this.summary) {
          this.summary.replaceChildren();
          if (this.selections.size === 0) {
            const empty = document.createElement('li');
            empty.className = 'bundle-builder__summary-empty';
            empty.textContent = this.dataset.emptyMessage;
            this.summary.append(empty);
          } else {
            this.selections.forEach((item) => {
              const row = document.createElement('li');
              const name = document.createElement('span');
              const quantity = document.createElement('strong');
              name.textContent = item.title;
              quantity.textContent = '×' + item.quantity;
              row.append(name, quantity);
              this.summary.append(row);
            });
          }
        }

        const remaining = this.maxItems - total;
        this.status.textContent = remaining === 0
          ? this.dataset.readyMessage
          : this.dataset.remainingTemplate.replace('__count__', remaining);
        this.progress.setAttribute('aria-valuenow', String(total));
        this.progressBar.style.width = ((total / this.maxItems) * 100) + '%';
        this.addButton.disabled = total !== this.maxItems;
        this.clearButton.disabled = total === 0;
      }

      filterProducts() {
        const term = this.search.value.trim().toLowerCase();
        let visible = 0;
        this.cards.forEach((card) => {
          const matches = card.dataset.title.includes(term);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (this.noResults) this.noResults.hidden = visible > 0;
      }

      clearSelections() {
        this.selections.clear();
        this.message.textContent = '';
        this.render();
      }

      async addBundle() {
        if (this.totalItems !== this.maxItems) return;
        this.addButton.disabled = true;
        this.clearButton.disabled = true;
        this.message.textContent = this.dataset.addingMessage;
        const properties = { _bundle: 'Build Your Own Bundle' };
        let teaNumber = 1;
        this.selections.forEach((item) => {
          for (let quantity = 0; quantity < item.quantity; quantity += 1) {
            properties['Tea ' + teaNumber] = item.title;
            teaNumber += 1;
          }
        });
        const items = [{
          id: this.dataset.bundleVariantId,
          quantity: 1,
          properties
        }];

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.href = root + 'cart';
        } catch (error) {
          this.message.textContent = this.dataset.errorMessage;
          this.addButton.disabled = false;
          this.clearButton.disabled = false;
        }
      }
    }

    customElements.define('bundle-builder', BundleBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
